































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import tableComponent from '@/components/TheTable.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import {
  requestResolveVoting,
  requestNewVoting,
  requestVote
} from '@/constants/sidebarData';
import { formatData } from '@/constants/commonContent';
import votingPdfMaker from '@/helpers/pdfmakers/voting';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE_TIME = formatData.dateTime;

@Component({
  name: 'VotingPage',
  components: {
    SidebarRight,
    tableComponent,
    titlePageComponent,
    PulseLoader
  }
})
export default class VotingPage extends Base {
  voteBtn = {
    text: 'New vote'
  };
  votingsTable = {
    titleText: 'PENDING VOTES',
    titleBg: 'orange-title',
    sorted: 'counter',
    columns: [
      { field: 'counter', title: '#' },
      { field: 'subject', title: 'TITLE' },
      { field: 'created', title: 'UPLOADED' },
      { field: 'creator', title: 'BY' },
      { field: 'deadlineTime', title: 'DEADLINE' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  pastVotingsTable = {
    titleText: 'PAST VOTES',
    titleBg: 'green-title',
    sorted: 'counter',
    columns: [
      { field: 'counter', title: '#' },
      { field: 'subject', title: 'TITLE' },
      { field: 'result', title: 'RESULT' },
      { field: 'creator', title: 'BY' },
      { field: 'resolvedTime', title: 'RESOLVED' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };

  // Computed
  get isVotingPending() {
    return this.getPendings.voting.new;
  }
  get isVotePending() {
    return this.getPendings.vote.id;
  }
  get isAgent() {
    return this.isReader;
  }
  get isOwnerRole() {
    return this.isOwner();
  }
  get votingsData() {
    let rows: any[] = [];
    let counter = 1;
    let now = Vue.moment();
    for (let variable in this.getVotings) {
      if (this.getVotings[variable].resolvedTime) continue;
      let row: any = {};
      let voting = this.getVotings[variable];
      row.counter = counter++;
      row.id = voting.id;
      row.subject = voting.subject;
      row.created = Vue.moment.unix(voting.createdTime).format(FORMAT_DATE_TIME);
      row.creator = this.getMember(voting.creator) ? this.getMember(voting.creator).name : '';
      let deadline = Vue.moment.unix(voting.deadlineTime);
      row.deadlineTime = deadline.format(FORMAT_DATE_TIME);
      if (now.isAfter(deadline)) {
        row.deadlineTime = 'Terminated';
        row.btnText = 'Resolve';
        row.action = this.resolveVoting;
      } else {
        if (this.getVotes[row.id]) {
          row.btnText = 'Voted';
          row.btnClass = 'voted';
        } else {
          row.btnText = 'Vote';
          row.action = this.vote;
        }
      }
      rows.push(row);
    }
    Vue.set(this.votingsTable, 'rows', rows);
    return this.votingsTable;
  }
  get pastVotingsData() {
    let rows: any[] = [];
    let counter = 1;
    for (let variable in this.getVotings) {
      if (!this.getVotings[variable].resolvedTime) continue;
      let row: any = {};
      let voting = this.getVotings[variable];
      row.counter = counter++;
      row.id = voting.id;
      row.subject = voting.subject;
      row.description = voting.description;
      row.passed = voting.passed;
      if (voting.passed) {
        row.result = 'Approved';
        row.styleClass = 'approved';
      } else {
        row.result = 'Denied';
        row.styleClass = 'denied';
      }
      row.creator = this.getMember(voting.creator) ? this.getMember(voting.creator).name : '';
      row.resolvedTime = Vue.moment.unix(voting.resolvedTime).format(FORMAT_DATE_TIME);
      rows.push(row);
    }
    Vue.set(this.pastVotingsTable, 'rows', rows);
    return this.pastVotingsTable;
  }

  // Methods
  vote(id) {
    const voting = this.getVotings[id];
    this.setSideBarForm(requestVote(voting));
    this.openClose();
  }
  resolveVoting(id) {
    const voting = this.getVotings[id];
    this.setSideBarForm(requestResolveVoting(voting));
    this.openClose();
  }
  downloadVoting(id) {
    const voting = this.getVotings[id];
    const filename = this.getTokenInfo.symbol + '_voting_#' + (id + 1);
    const data = {
      resolvedTime: this.$moment.unix(voting.resolvedTime).format(FORMAT_DATE_TIME),
      passed: voting.passed,
      subject: voting.subject,
      description: voting.description
    };

    this.getVotingVotesDapp(id).then(res => {
      votingPdfMaker(data, res, this.getMember, this.getOwners).download(filename);
    });
  }
  requestNewVoting() {
    this.setSideBarForm(requestNewVoting());
    this.openClose();
  }
}
